app.component('medicalAdd', {
    templateUrl: 'app/medical/medical_add.html',
    controller: function ( $location, $routeParams, medicalUtil ) {
        var $ctrl = this;
        var _nowEntry = ''; // 選択日付のバックアップ用
        $ctrl.medicalData = {};
        $ctrl.$onInit = function () {
            //最初は登録ボタンは無効にしておく。
            $ctrl.addbtn_enable = false;
            $ctrl.maxDate = moment().toDate();
            if( $routeParams.mode == 'update' ) {
                $ctrl.medicalData = medicalUtil.getMedicalData( $routeParams.entry );
                $ctrl.addbtn_enable = true;
                $ctrl.entryDate = moment( $routeParams.entry, "YYYY-MM-DD 00:00:00" ).toDate();
                _nowEntry = $ctrl.entryDate;
            }
        };
        $ctrl.addmedical = function () {
            $ctrl.medicalData.medicalEntry = moment( $ctrl.entryDate ).format("YYYY-MM-DD 00:00:00");
            $ctrl.medicalData.medicalBMI = medicalUtil.calcBMI($ctrl.medicalData.medicalWeight, $ctrl.medicalData.medicalHeight);
            $ctrl.medicalData.medicalBasal = medicalUtil.calcBMR($ctrl.medicalData.medicalWeight, $ctrl.medicalData.medicalHeight, $ctrl.medicalData.medicalAge, $ctrl.medicalData.medicalGender);
            switch($routeParams.mode) {
                case "insert" : // 追加モードの場合
                medicalUtil.addMedicalData( $routeParams.medicalId, $ctrl.medicalData );
                    break;
                case "update" : // 更新モードの場合
                medicalUtil.updMedicalDataById( $routeParams.medicalId, $ctrl.medicalData );
                    break;
            }
            alert("健診データを登録しました");
            $location.path("/medical_main");
        };
        $ctrl.doubleCheckEntry = function() {
            var entry = moment( $ctrl.entryDate ).format( "YYYY-MM-DD 00:00:00" );
            if( $routeParams.entry != entry && medicalUtil.getMedicalDataByEntry( entry ) != null ) {
                alert( "選択された日付は既に登録済みです。\n別な日付を選択してください。" );
                if( $routeParams.mode == 'update' ) {
                    $ctrl.addbtn_enable = true;
                }
                else {
                    if( _nowEntry == "") {
                        $ctrl.addbtn_enable = false;
                    }
                }
                $ctrl.entryDate = _nowEntry;
            }
            else {
                $ctrl.addbtn_enable = true;
                _nowEntry = $ctrl.entryDate;
            }
        }
    }
});
